import React from "react";
import { EntityStatus } from "../../Constants/Constants";
import ListServiceInstance from "./ListServiceInstance";
import { message } from "antd";
import { convertServiceInstanceList } from "../../Helpers/ServiceInstanceHelpers";
import ServiceInstanceForm from "./ServiceInstanceForm";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";

class ServiceInstance extends React.Component {
  constructor(props) {
    super(props);
    this.header = [...(props.parentBread || []), "Service Instance"];
    this.state = {
      action: null,
      record: null,
      instanceData: null,
      instanceDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateInstanceList();
  }

  updateInstanceList() {
    console.log("updateInstanceList...");
    const {
      record: { key },
    } = this.props;
    this.setState({ instanceDataLoading: true });

    const errorCallback = () => {
      message.error("Error fetching Service Instance list");
      this.setState({ instanceDataLoading: false });
    };
    try {
      this.props.serviceInstanceApi.getServiceInstanceByServiceId(
        key,
        apiCallback({
          history: this.props.history,
          errorCallback,
          successCallback: (data) => {
            const instanceData = convertServiceInstanceList(data);
            console.log("updateInstanceList data", instanceData);
            this.setState({ instanceData, instanceDataLoading: false });
          },
        })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateInstanceList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    const {
      record: { serviceId },
      serviceInstanceApi,
    } = this.props;
    const instanceId = record.instanceId;
    try {
      console.log("onStatusChange", status, serviceId, instanceId);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(serviceId, instanceId, !status),
      });
      if (status) {
        serviceInstanceApi.activateServiceInstance(
          serviceId,
          instanceId,
          callback
        );
      } else {
        serviceInstanceApi.inActivateServiceInstance(
          serviceId,
          instanceId,
          callback
        );
      }
      this.changeStatus(instanceId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  changeStatus = (instanceId, status) => {
    const instanceData = [...this.state.instanceData];
    instanceData.forEach((inst) => {
      if (inst.instanceId === instanceId) {
        inst.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
      }
    });
    this.setState({ instanceData });
  };

  render() {
    const { action, record, instanceData, instanceDataLoading } = this.state;
    return (
      <div className="service-instance-container">
        {!action ? (
          <ListServiceInstance
            instanceDataLoading={instanceDataLoading}
            instanceData={instanceData}
            onActionClick={this.onActionClick}
            onParentActionClick={this.props.onActionClick}
            onStatusChange={this.onStatusChange}
            parentBread={this.header}
          />
        ) : (
          <ServiceInstanceForm
            action={action}
            instanceRecord={record}
            serviceRecord={this.props.record}
            onSubmit={this.onSubmit}
            onActionClick={this.onActionClick}
            parentBread={this.header}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceInstanceApi: state.apis.serviceInstanceApi,
});

const connectedServiceInstance = connect(mapStateToProps)(ServiceInstance);

export default withRouter(connectedServiceInstance);
